import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'Components/Modal';
import EnvironmentManager from 'Utils/environmentManager';
import { useDispatch } from 'react-redux';
import { closeModal } from 'Store/actions';
import History from 'Store/history';

const GeneralErrorModal = props => {
  const genericErrorTitle = EnvironmentManager.getMessageText({ key: 'title_raffle_ticket_purchase_generic_error' }) || 'Bilgilendirme';
  const genericErrorMessage = EnvironmentManager.getMessageText({ key: 'description_raffle_ticket_purchase_generic_error' }) || 'İşlem sırasında bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.';
  const turnBackRaffleBtnText = EnvironmentManager.getMessageText({ key: 'button_turn_back_to_raffle' }) || 'Çekilişleri Gör';
  const turnBackSantraBtnText = EnvironmentManager.getMessageText({ key: 'button_turn_back_to_santra' }) || 'Santra';
  const dispatch = useDispatch();
  const { turnBackSantra, forceBackOnClose } = props;

  return (
    <Modal
      onClose={ () => {
        if (forceBackOnClose) {
          turnBackSantra ? History.push('/') : History.push('/sans-oyunlari/esya-piyangosu');
        }
        dispatch(closeModal('raffleErrorModal'));
      }
      }
      title={ genericErrorTitle }
      type="error"
      iconName="svgInfoRed"
      buttonArea= { {
        primaryButton: {
          children: turnBackSantra ? turnBackSantraBtnText : turnBackRaffleBtnText,
          onClick: () => {
            turnBackSantra ? History.push('/') : History.push('/sans-oyunlari/esya-piyangosu');
            dispatch(closeModal('raffleErrorModal'));
          }
        }
      } }
    >
      { genericErrorMessage }
    </Modal>
  );
};

GeneralErrorModal.propTypes = {
  message: PropTypes.string,
  modalClose: PropTypes.func,
  turnBackSantra: PropTypes.bool,
  forceBackOnClose: PropTypes.bool,
};

export default GeneralErrorModal;
